<template>
  <path
    d="M21.59 12.5802C21.84 12.2302 21.84 11.7702 21.59 11.4202L17.63 5.84019C17.27 5.33019 16.67 5.00019 16 5.00019H8.65998L19.36 15.7302L21.59 12.5802ZM2.71998 4.72019L3.58998 5.59019C3.22998 5.95019 2.99998 6.45019 2.99998 7.00019V17.0002C2.99998 18.1002 3.89998 19.0002 4.99998 19.0002H17L18.29 20.2902C18.68 20.6802 19.31 20.6802 19.7 20.2902C20.09 19.9002 20.09 19.2702 19.7 18.8802L4.13998 3.31019C3.75998 2.93019 3.12998 2.92019 2.73998 3.30019C2.32998 3.68019 2.32998 4.33019 2.71998 4.72019Z"
  />
</template>
